import type { ReactNode } from 'react';
import { CircleAlert } from 'lucide-react';
import { Card } from './Card';
import { Chargement } from './Chargement';
import { EtatVide } from './EtatVide';
import type { Lecture } from './useDonnees';

/** Affiche une lecture : le sablier, l'erreur, ou le contenu une fois prêt. */
export function Lecteur<T>({
  lecture,
  children,
}: {
  lecture: Lecture<T>;
  children: (donnees: T) => ReactNode;
}) {
  if (lecture.statut === 'chargement') return <Chargement plein={false} />;
  if (lecture.statut === 'erreur') {
    return (
      <Card>
        <EtatVide icone={CircleAlert} titre="Lecture impossible">
          {lecture.message}
        </EtatVide>
      </Card>
    );
  }
  return children(lecture.donnees);
}
